<template lang="pug">
	div
		b-card-text(v-if="ppntChildren.length")
			h5 Моя группа
			groupTable(:_items="children" :_fields="fields" :_ppnt="myParticipant")
		b-card-text(v-else)
			extraDatas(:_ppnt="myParticipant")
		div.g-full-center(v-if="!isSelectionStage")
			b-button.mb-3(variant='primary' @click="$bvModal.show('addExtraParticipantModal')" ) Добавить участника

		addExtraParticipantModal(v-if="!isSelectionStage" :_event="myParticipant.data.event")
</template>

<script>
	import { mapState } from 'vuex'

	import groupTable from '../components/groupTable'
	import extraDatas from '../components/extraDatas'
	import addExtraParticipantModal from '../components/addExtraParticipantModal'

	export default {
		name: 'InfoTab',
		components: {
			groupTable,
			extraDatas,
			addExtraParticipantModal,
		},
		data: () => ({
			fields: [
				{ key: 'index', label: '№' },
				{ key: 'user', label: 'Участник' },
				{ key: 'reg_extra_data', label: 'Условия участия' },
				{ key: 'session_approved', label: 'Доклад подтвержден' },
				'price'
			]
		}),
		computed: {
			...mapState(['myParticipant']),

			children(){ return (this.ppntChildren || []).reduce( (acc,item) => [...acc, item],[this.myParticipant.data]) },
			ppntChildren(){ return this.myParticipant.data.children },
			isSelectionStage(){ return this.myParticipant.data.stage.order>=this.myParticipant.data.event.selection_stage.order },
		},
	}
</script>
